import { resetPciVault } from "../../redux/reducers/creditCard";
import { useEffect } from "react";
import "./creditCardSuccess.css";
import { useDispatch } from "react-redux";

export default function CreditCardSuccess() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetPciVault());
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="cc-submit">
      <span>Order is placed!</span>
      <br />
      <br />
      <h2>Thank you for your order</h2>
      <br />
      <br />
      Order is pending, as soon as we finalise your order,a confirmation email
      will be sent to your email.
      <br />
      <br />
      Business orders could take up to 10 days, and you might get emails and
      called by our customer support agent.
      <br />
      <br />
      Thank you for choosing us!
    </div>
  );
}
